import{defineMessages}from'react-intl';

export default defineMessages({
button_back:{
id:'i18n.stock_lift_detail.button_cancel',
defaultMessage:'Cancel'},

button_submit:{
id:'i18n.stock_lift_detail.button_submit',
defaultMessage:'Submit'},

button_edit:{
id:'i18n.stock_lift_detail.button_edit',
defaultMessage:'Edit'},

label_quarter:{
id:'i18n.stock_lift_detail.label_quarter',
defaultMessage:'Quarter'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9WaWV3RWRpdFN0b2NrTGlmdFBhZ2UvU3RvY2tMaWZ0RGV0YWlsL1N0b2NrTGlmdERldGFpbC5tZXNzYWdlcy5qcyJdLCJuYW1lcyI6WyJkZWZpbmVNZXNzYWdlcyIsImJ1dHRvbl9iYWNrIiwiaWQiLCJkZWZhdWx0TWVzc2FnZSIsImJ1dHRvbl9zdWJtaXQiLCJidXR0b25fZWRpdCIsImxhYmVsX3F1YXJ0ZXIiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLFlBQWE7QUFDWEMsR0FBSSxzQ0FETztBQUVYQyxlQUFnQixRQUZMLENBRGU7O0FBSzVCQyxjQUFlO0FBQ2JGLEdBQUksc0NBRFM7QUFFYkMsZUFBZ0IsUUFGSCxDQUxhOztBQVM1QkUsWUFBYTtBQUNYSCxHQUFJLG9DQURPO0FBRVhDLGVBQWdCLE1BRkwsQ0FUZTs7QUFhNUJHLGNBQWU7QUFDYkosR0FBSSxzQ0FEUztBQUViQyxlQUFnQixTQUZILENBYmEsQ0FBZixDQUFmIiwiZmlsZSI6IlN0b2NrTGlmdERldGFpbC5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBidXR0b25fYmFjazoge1xuICAgIGlkOiAnaTE4bi5zdG9ja19saWZ0X2RldGFpbC5idXR0b25fY2FuY2VsJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0NhbmNlbCcsXG4gIH0sXG4gIGJ1dHRvbl9zdWJtaXQ6IHtcbiAgICBpZDogJ2kxOG4uc3RvY2tfbGlmdF9kZXRhaWwuYnV0dG9uX3N1Ym1pdCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdTdWJtaXQnLFxuICB9LFxuICBidXR0b25fZWRpdDoge1xuICAgIGlkOiAnaTE4bi5zdG9ja19saWZ0X2RldGFpbC5idXR0b25fZWRpdCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdFZGl0JyxcbiAgfSxcbiAgbGFiZWxfcXVhcnRlcjoge1xuICAgIGlkOiAnaTE4bi5zdG9ja19saWZ0X2RldGFpbC5sYWJlbF9xdWFydGVyJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1F1YXJ0ZXInLFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/pages/ViewEditStockLiftPage/StockLiftDetail/StockLiftDetail.messages.js
// module id = 2339
// module chunks = 0